/**
 * Clinic Heat Map (staff) — client wrapper around `listClinicCoverageForStaff`.
 *
 * Returns a today + 7-day coverage runway for every active clinic across every
 * org. Staff-gated server-side (`requireStaff`). Counts-only model: empty days
 * are real booking gaps, sync issues mean the pull broke or never ran.
 */

import { httpsCallable } from 'firebase/functions'
import { functions } from '../config'

export type CellState = 'healthy' | 'low' | 'empty' | 'syncerror' | 'pending' | 'nodata' | 'closed'
export type ClinicCoverageStatus = 'attention' | 'sync' | 'healthy' | 'new'

export interface CoverageDay {
  iso: string
  dow: string
  weekend: boolean
  today: boolean
}
export interface CoverageCell {
  state: CellState
  count?: number
  note?: string
}
export interface ClinicCoverageRow {
  orgId: string
  org: string
  clinicId: string
  name: string
  region: string
  /** The practice's main login — earliest-created admin user's email. */
  mainLogin: string | null
  status: ClinicCoverageStatus
  cells: CoverageCell[]
}
export interface ClinicCoverageResult {
  generatedAt: string
  businessTz: string
  days: CoverageDay[]
  maxCount: number
  summary: {
    clinics: number
    attention: number
    sync: number
    healthy: number
    new: number
  }
  clinics: ClinicCoverageRow[]
}

/** Fetch fleet-wide clinic coverage for the staff heat map. */
export async function listClinicCoverage(): Promise<ClinicCoverageResult> {
  const fn = httpsCallable<Record<string, never>, ClinicCoverageResult>(functions, 'listClinicCoverageForStaff')
  const res = await fn({})
  return res.data
}
